import Vue from "vue";
import "./plugins/vuetify";
import "./plugins/vuse";
import App from "./App.vue";
import router from "./router";
import { store } from "./store";


import ShowError from './components/showError';

// Install the authentication plugin here
// import AuthPlugin from "./plugins/auth";
// Vue.use(AuthPlugin);


import { Auth0Plugin } from "./plugins/auth0";
Vue.use(Auth0Plugin, {
   domain: "taskteacher.auth0.com",
   clientId: process.env.VUE_APP_AUTH0_CLIENT_ID,
   audience: "https://api.taskteacher.com",
   onRedirectCallback: appState => {
      router.push(
         appState && appState.targetUrl
            ? appState.targetUrl
            : window.location.pathname
      );
   }
});




Vue.component('my-show-error', ShowError );

Vue.config.productionTip = false;

//note the definition of these global vars now takes place in plugins/vuse.js
// Vue.prototype.$baseUrlApi = 'http://localhost:3600';
// Vue.prototype.$baseUrl = 'http://localhost:3500';










let vm = new Vue({router, store, render: h => h(App) });
vm.$mount("#app");
